/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { MainChart } from './components/MainChart'
import { Monitoring } from './components/Monitoring'
import { ChartDaily } from './components/ChartDaily'
import { ChartMontly } from './components/ChartMonthly'

const DashboardPage = ({ statusColor = '', setstatusColor = {}, lastDate = '', setLastDate = {}, lastUnit = '', setLastUnit = {} }) => (
   
  <>
    <div className='row g-3 g-xl-10 mb-1'>
      <div className='col-lg-6 col-md-12'>
        <MainChart statusColor={statusColor} setstatusColor={setstatusColor} lastDate={lastDate} setLastUnit={setLastUnit} className='card-xxl-stretch mb-8' />
      </div>
      <div className='col-lg-6 col-md-12'>
        <Monitoring statusColor={statusColor} className='card-xxl-stretch mb-8' />
      </div>
    </div>
    <div className='row g-3 g-xl-10 mb-10'>
      <div className='col-lg-6 col-md-12'>
        <ChartDaily statusColor={statusColor} setLastDate={setLastDate} className='card-xl-stretch' lastUnit={lastUnit}  />
      </div>
      <div className='col-lg-6 col-md-12'>
        <ChartMontly statusColor={statusColor} className='card-xl-stretch' lastUnit={lastUnit}/>
      </div>
    </div>
  </>
)

const DashboardWrapper: FC = () => {
  // const [statusColor, setstatusColor] = useState('badge-light-secondary')
  const [statusColor, setstatusColor] = useState('badge-light-warning')
  const [lastDate, setLastDate] = useState('');
  const [lastUnit, setLastUnit] = useState('MMBtu');
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage 
        statusColor={statusColor} 
        setstatusColor={setstatusColor} 
        lastDate={lastDate} 
        setLastDate={setLastDate}  
        lastUnit={lastUnit} 
        setLastUnit={setLastUnit}/>
    </>
  )
}

export { DashboardWrapper }
